import { render, staticRenderFns } from "./salesPlatform.vue?vue&type=template&id=52734122&scoped=true&"
import script from "./salesPlatform.vue?vue&type=script&lang=js&"
export * from "./salesPlatform.vue?vue&type=script&lang=js&"
import style0 from "./salesPlatform.vue?vue&type=style&index=0&id=52734122&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52734122",
  null
  
)

export default component.exports